import { Button, ButtonProps, Typography } from '@mui/material';
import { styled } from '@mui/system';


const StyledButton = styled(Button)<ButtonProps>(({ theme, color, isSelected, }) => {
  const isPrimaryColor = color === 'primary'
  const background = !isPrimaryColor ? {
    backgroundColor: theme.palette.background[color],
    border: `1px solid ${theme.palette.background.border}`,
    color: theme.palette[isPrimaryColor ? 'secondary' : 'primary'].contrastText,
  } : {}
  const colorConfig = isSelected ? {
    color: theme.palette.brand.primary
  } : { color: theme.palette[isPrimaryColor ? 'primary' : 'secondary'].contrastText }
  return ({
    borderRadius: theme.shape.borderRadius,
    cursor: 'pointer',
    ...background,
    ...colorConfig
  })
}
)

const AppliedStyle = (props: any) => {
  const { children, size } = props

  let variant: any = 'xs'
  switch (size) {
    case 'small':
      variant = 'xs'
      break;
    case 'medium':
      variant = 's'
      break;
    case 'large':
      variant = 'r'
      break;
  }
  return <StyledButton {...props} disableRipple>
    <Typography variant={variant}>{children}</Typography>
  </StyledButton>
}

export default AppliedStyle